import type { Node } from '@xyflow/react'
import { useStoreApi } from '@xyflow/react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ITERATION_PADDING } from '../constants'

export const useNodeIterationInteractions = () => {
    const { t } = useTranslation()
    const store = useStoreApi()

    const handleNodeIterationChildDrag = useCallback(
        (node: Node) => {
            const { nodes } = store.getState()

            const restrictPosition: { x?: number; y?: number } = { x: undefined, y: undefined }

            if (node.data.isInIteration) {
                const parentNode = nodes.find(n => n.id === node.parentId)
                const nodeWidth = node.width ?? 0
                const nodeHeight = node.height ?? 0
                if (parentNode) {
                    const parentNodeWidth = parentNode.width ?? 0
                    const parentNodeHeight = parentNode.height ?? 0
                    if (node.position.y < ITERATION_PADDING.top) {
                        restrictPosition.y = ITERATION_PADDING.top
                    }
                    if (node.position.x < ITERATION_PADDING.left) {
                        restrictPosition.x = ITERATION_PADDING.left
                    }
                    if (node.position.x + nodeWidth > parentNodeWidth - ITERATION_PADDING.right) {
                        restrictPosition.x = parentNodeWidth - ITERATION_PADDING.right - nodeWidth
                    }
                    if (node.position.y + nodeHeight > parentNodeHeight - ITERATION_PADDING.bottom) {
                        restrictPosition.y = parentNodeHeight - ITERATION_PADDING.bottom - nodeHeight
                    }
                }
            }

            return {
                restrictPosition
            }
        },
        [store]
    )

    return {
        handleNodeIterationChildDrag
    }
}
